import React from "react";
import { CocoImageText, CocoImageWrapper } from "./nps-coco-image.styles";
import { INpsCocoImageProps } from "./nps-coco-image.types";
import { useNpsCocoImage } from "./useNpsCocoImage";

const NpsCocoImage: React.FC<INpsCocoImageProps> = ({ rating }) => {
  const { color, imageSrc, text } = useNpsCocoImage(rating);
  return (
    <CocoImageWrapper backgroundImage={imageSrc}>
      <CocoImageText color={color}>{text}</CocoImageText>
    </CocoImageWrapper>
  );
};

export { NpsCocoImage };
